export class DefaultEncoder {
  uuid: string;
  name: string;
  commandsSchema: string;
  creationDate: number;
  updatedDate: number;

  constructor(uuid?: string, name?: string, commandsSchema?: string, creationDate?: number, updatedDate?: number) {
    this.uuid = uuid;
    this.name = name;
    this.commandsSchema = commandsSchema;
    this.creationDate = creationDate;
    this.updatedDate = updatedDate;
  }
}
